import { render, staticRenderFns } from "./registroStock.vue?vue&type=template&id=2e4d5169&"
import script from "./registroStock.vue?vue&type=script&lang=js&"
export * from "./registroStock.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports